"use client";
import React, { ComponentProps } from "react";
import { Chip, Radio } from "@cappelendamm/design-system/react";
import classNames from "classnames";

export type RadioAttributes = {
  label: string;
  icon?: React.ReactNode;
  description?: string;
  chipText?: string;
  input: ComponentProps<typeof Radio>;
};

export type RadioOptionProps = {
  radioAttributes: RadioAttributes;
};

export default function RadioOption({ radioAttributes }: RadioOptionProps) {
  const { label, description, icon, chipText, input } = radioAttributes;

  return (
    <label
      className={classNames(
        "relative flex flex-col gap-3 rounded-xl border bg-gray-50 px-3 py-7 hover:cursor-pointer",
        {
          "text-gray-400 hover:cursor-default": input.disabled,
          "border-gray-600": input.checked,
        },
      )}
    >
      {chipText && (
        <div className="absolute top-[-1.2em] right-[0.5em]">
          <Chip variant="primary">
            <p>{chipText}</p>
          </Chip>
        </div>
      )}
      <div className="flex w-full justify-between">
        <div className="flex items-center gap-4">
          <Radio
            type="radio"
            {...input}
            className="disabled:before:border-gray-400"
          />
          <p>{label}</p>
        </div>
        {icon}
      </div>
      {description && input.checked && (
        <p className="rounded-[4px] p-2 text-gray-900">{description}</p>
      )}
    </label>
  );
}
